import { RouterManager } from '@aclass/admin/managers';
import { EmailPipelineStory } from '@aclass/admin/storage/actions';
import { IAdminState, IEmailPipelineModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable()
export class EmailPipelineEditStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:email-pipeline-edit';

    private id: string;

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<IEmailPipelineModuleState['editPageRecordId']>(['emailPipelineModule', 'editPageRecordId']).pipe(
            filter(v => v === this.id)
        );
        this.employee = this.routerManager.onRejectNavigation(EmailPipelineEditStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(route: ActivatedRouteSnapshot): void {
        this.id = route.params.id;
        this.ngRdx.dispatch(EmailPipelineStory.dryRunEditPage(this.id));
    }
}
